<template>
  <div class="comments-collection">
    <UserTitle
      :border="true"
      :tab="true"
      :tabList="tabList"
      :active="active"
      :tabClick="tabClick"
    ></UserTitle>
    <div class="spin-margin" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <div v-if="!loading">
      <div
        class="comments-collection-content"
        v-if="projectData && projectData.length > 0"
      >
        <div v-if="type == 'post'">
          <b-row
            class="comments-project collection-content"
            v-for="(item, index) in projectData"
            :key="index"
          >
            <b-col cols="12" md="8" v-if="item.post">
              <h5>{{ item.post.title }}</h5>
              <span>
                {{ item.post.source ? `${item.post.source} | ` : "未知 | " }}
                {{ getDate(item.post.createTime) }}
              </span>
              <p class="maxLength-text-2">{{ item.post.digest }}</p>
              <div>
                <div class="projects-contexts">
                  <a @click="goDetails(item.post.id)">
                    查看详情
                    <i></i>
                  </a>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4" v-if="item.post">
              <img :src="getImgUrl(item.post.photoUrl)" alt />
            </b-col>
          </b-row>
        </div>
        <div v-if="type == 'project'">
          <b-row
            class="comments-project collection-content"
            v-for="(item, index) in projectData"
            :key="index"
          >
            <b-col cols="12" md="8" v-if="item.project">
              <h5>{{ item.project ? item.project.name : "" }}</h5>
              <span>{{ getDate(item.project.startDate) }}</span>
              <p class="maxLength-text-2" v-html="item.project.projectDesc"></p>
              <div>
                <div class="projects-contexts">
                  <a @click="goDetails(item.project.id)">
                    查看详情
                    <i></i>
                  </a>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4" v-if="item.project">
              <img :src="getImgUrl(item.project.projectPhotoUrl)" alt />
            </b-col>
          </b-row>
        </div>
        <b-pagination
          v-if="page.show"
          class="ltitle-page solution-page"
          style="justify-content: center;"
          v-model="page.current"
          :total-rows="page.rows"
          :perPage="page.perPage"
          first-number
          last-number
        ></b-pagination>
      </div>
      <a-empty class="empty" description="暂无收藏" v-else />
    </div>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      type: "post",
      active: 0,
      projectData: [],
      tabList: ["新闻资讯", "项目机会"],
      page: {
        current: 1,
        rows: 1,
        perPage: 5,
        show: false
      },
      loading: false
    };
  },
  watch: {
    "page.current": {
      deep: true,
      handler: function() {
        this.getData(this.type);
        window, scrollTo(0, 0);
      }
    }
  },
  mounted() {
    this.getData(this.type);
  },
  methods: {
    async getData(type) {
      this.loading = true;
      try {
        let query = {
          pageSize: this.page.perPage,
          current: this.page.current,
          type: type
        };
        const data = await Api.Collection.getCollection(query);
        if (data.data && data.data.length > 0) {
          this.page.show = true;
        } else {
          this.page.show = false;
        }
        this.loading = false;
        this.page.rows = data.total;
        this.projectData = data.data;
      } catch (e) {
        this.$message.error(e);
      }
    },
    tabClick(item, index) {
      this.projectData = [];
      this.active = index;
      if (item == "新闻资讯") {
        this.getData("post");
        this.type = "post";
        this.page.current = 1;
      }
      if (item == "项目机会") {
        this.getData("project");
        this.type = "project";
        this.page.current = 1;
      }
    },
    goDetails(id) {
      if (this.type == "post") {
        this.$router.push({
          path: "/new/details",
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: "/product/projectDetails",
          query: {
            id: id
          }
        });
      }
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    getDate(time) {
      return publicChange.getDate(time);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    //转换时间戳
    changeDataTime(date) {
      let time = new Date(date);
      return this.$moment(time).format("YYYY.MM.DD");
    }
  }
};
</script>
<style scoped>
.comments-project h5 {
  font-size: 22px;
  font-weight: 400;
  color: #333333;
  line-height: 33px;
  text-align: left;
  margin-bottom: 5px;
}
.comments-project p {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  text-align: left;
}
.collection-content {
  text-align: left;
  padding-bottom: 50px;
}
.comments-project span {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  text-align: left;
  margin-top: 23px;
  display: inline-block;
}
.comments-project h5 {
  margin-bottom: 10px !important;
}
.comments-project span {
  margin-top: 0 !important;
  margin-bottom: 16px;
}
.comments-project img {
  height: 164px;
}
.comments-collection-content {
  margin: 50px 0px 30px 0px;
}
</style>
